define("ember-cli-string-helpers/helpers/lowercase", ["exports", "@ember/component/helper", "ember-cli-string-helpers/utils/lowercase", "ember-cli-string-helpers/-private/create-string-helper"], function (_exports, _helper, _lowercase, _createStringHelper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.lowercase = _exports.default = void 0;
  const lowercase = _exports.lowercase = (0, _createStringHelper.default)(_lowercase.default);
  var _default = _exports.default = (0, _helper.helper)(lowercase);
});